// src/components/strumenti/ConversioneAwgMmq.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

// Formula standard AWG: diametro(mm) = 0.127 * 92^((36-AWG)/39)
// Per le sezioni "grosse" americane (1/0, 2/0, 3/0, 4/0) si usa AWG negativo: 1/0=-1, 2/0=-2, 3/0=-3, 4/0=-4
function awgToMmq(awg) {
  const d = 0.127 * Math.pow(92, (36-awg)/39);
  return (Math.PI/4) * d * d;
}
function mmqToAwg(mmq) {
  const d = Math.sqrt((4*mmq)/Math.PI);
  return 36 - 39 * (Math.log(d/0.127)/Math.log(92));
}
const SEZIONI_COMMERCIALI = [0.5,0.75,1,1.5,2.5,4,6,10,16,25,35,50,70,95,120,150,185,240,300];

export default function ConversioneAwgMmq() {
  const [modo, setModo] = useState("awg_mmq");
  const [valore, setValore] = useState("");

  const v = leggiNumero(valore);
  let risultato = null, sezioneVicina = null;
  if (!isNaN(v)) {
    if (modo === "awg_mmq") {
      risultato = awgToMmq(v);
      sezioneVicina = SEZIONI_COMMERCIALI.find(s => s >= risultato) || null;
    } else {
      risultato = mmqToAwg(v);
    }
  }

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("awg_mmq");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="awg_mmq"?"#7c3aed":"#e5e7eb"}`, background: modo==="awg_mmq"?"#faf5ff":"#fff", color: modo==="awg_mmq"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>AWG → mm²</button>
        <button onClick={()=>{setModo("mmq_awg");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="mmq_awg"?"#7c3aed":"#e5e7eb"}`, background: modo==="mmq_awg"?"#faf5ff":"#fff", color: modo==="mmq_awg"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>mm² → AWG</button>
      </div>

      <div style={{ marginBottom:16 }}>
        <label style={lbl}>{modo==="awg_mmq" ? "Sezione AWG (usa 0, -1, -2, -3 per 1/0, 2/0, 3/0, 4/0)" : "Sezione (mm²)"}</label>
        <input value={valore} onChange={e=>setValore(e.target.value)} style={inp} placeholder={modo==="awg_mmq" ? "Es. 12" : "Es. 6"}/>
      </div>

      <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{modo==="awg_mmq" ? "Sezione equivalente" : "AWG equivalente (indicativo)"}</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#7c3aed" }}>
          {risultato===null || isNaN(risultato) ? "—" : risultato.toLocaleString("it-IT",{maximumFractionDigits:2})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="awg_mmq" ? "mm²" : "AWG"}</span>
        </div>
        {modo==="awg_mmq" && sezioneVicina && (
          <div style={{ fontSize:11, color:"#6b7280", marginTop:6 }}>Sezione commerciale più vicina: <strong>{sezioneVicina} mm²</strong></div>
        )}
      </div>

      <button onClick={()=>setValore("")}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
